import React, { useState, useEffect } from 'react';
import { Formik } from 'formik';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import FormWrapper from '~FormWrapper';
import OperatingRoomCleanForm from './OperatingRoomCleanForm';

import { useOnSubmit, useOnEdit } from '~hooks';
import { getOperatingRooms } from '~services/api.helpers';
import { removeEmptyKeys } from '../validations';

const validate = values => {
  const errors = {};

  if (!values.room) {
    errors.room = 'Vaadittu';
  }

  if (!values.taskSubType) {
    errors.taskSubType = 'Vaadittu';
  }

  return removeEmptyKeys(errors);
};

const OperatingRoomClean = props => {
  const { formId, edit } = props;
  const { orderId } = useParams();
  const [operatingRooms, setOperatingRooms] = useState([]);

  const orgId = useSelector(state => state.user?.data?.ordererOrganization?.id);

  useEffect(() => {
    const update = async () => {
      const newOperatingRooms = await getOperatingRooms(orgId);
      setOperatingRooms(newOperatingRooms);
    };

    update();
  }, [orgId]);

  const onFormSubmit = useOnSubmit();
  const onFormEdit = useOnEdit();

  return (
    <Formik
      validate={validate}
      initialValues={{
        room: null,
        taskSubType: null,
        urgency: null,
        leadVests: 'NO',
        supports: 'NO',
        additionalInfo: '',
      }}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        const method = edit ? onFormEdit : onFormSubmit;
        await method({
          fields: {
            ...values,
          },
          setSubmitting,
          formId,
          orderId,
        });
      }}
    >
      {formikProps => (
        <FormWrapper
          {...props}
          title="Vuodesiivous"
          formik={formikProps}
          Component={OperatingRoomCleanForm}
          operatingRooms={operatingRooms}
        />
      )}
    </Formik>
  );
};

export default OperatingRoomClean;
